import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import SafeDrivingGuideKr from '@di-shared/features/safe-driving/kr/SafeDrivingGuide.kr';

function SafeDrivingGuidePage() {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T40149')}</h1>
      </Header>
      <SafeDrivingGuideKr />
    </div>
  );
}

export default SafeDrivingGuidePage;
